var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Tool to override any query settings. Be careful with this, as it can override any query settings and can cause unexpected results.
 *
 * @category Modifier
 * @param settingsToOverride
 * @returns
 */
export function overrideSettings(settingsToOverride) {
    return {
        klevuModifierId: "overrideSettings",
        modifyAfter: (queries) => __awaiter(this, void 0, void 0, function* () {
            const copy = Array.from(queries);
            for (const q of copy) {
                q.settings = Object.assign(Object.assign({}, q.settings), settingsToOverride);
            }
            return copy;
        }),
    };
}
